import { sameJson } from './sameJson';

/**
 * Three-way rebase of an open drawer's draft onto a task that changed
 * underneath it (an early finish moving the dates server-side, a schedule
 * rebase, an auto-saved field): every field the user has NOT touched since the
 * drawer opened (`draft[k]` still equals `base[k]`) takes the live value; a
 * field they edited keeps their edit. Without this the drawer kept showing —
 * and a drawer Save wrote back — the pre-finish end date.
 */
export function rebaseDraft<T extends object>(base: T, draft: T, live: T): T {
  const next = { ...draft } as Record<string, unknown>;
  const baseRecord = base as Record<string, unknown>;
  const liveRecord = live as Record<string, unknown>;
  for (const key of new Set([...Object.keys(baseRecord), ...Object.keys(liveRecord)])) {
    if (sameJson(next[key], baseRecord[key])) next[key] = liveRecord[key];
  }
  return next as T;
}
